import { useMemo } from "react";
import {
  HappycoWorkOrdersQuery,
  HappycoWorkOrdersQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import HAPPYCO_WORK_ORDERS_QUERY from "./_networking/happyco-work-orders";

interface IProps {
  happycoWorkOrderId?: string | null;
}

const useHappycoWorkOrder = ({ happycoWorkOrderId }: IProps) => {
  const { data } = useQuery<
    HappycoWorkOrdersQuery,
    HappycoWorkOrdersQueryVariables
  >(HAPPYCO_WORK_ORDERS_QUERY, {
    variables: {
      happycoIds: happycoWorkOrderId ? [happycoWorkOrderId] : [],
    },
    skip: !happycoWorkOrderId,
  });

  const happycoWorkOrder = useMemo(() => {
    if (!data || data.happycoWorkOrders.length === 0) {
      return undefined;
    }
    return data.happycoWorkOrders[0];
  }, [data]);

  return {
    happycoWorkOrder,
  };
};

export default useHappycoWorkOrder;
